import React from 'react'
import PropTypes from 'prop-types'

const ActionModerateMessagesOutline12 = ({ className, color, height, strokeWidth, width }) => (
   <svg width={width} height={height} viewBox="0 0 12 12">
      <g
         className={className}
         stroke={color}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}>
         <rect height="5" width="11" fill="none" strokeLinecap="round" x="0.5" y="0.5" />
         <line fill="none" strokeLinecap="round" x1="0.5" x2="11.5" y1="8.5" y2="8.5" />
         <line fill="none" strokeLinecap="round" x1="0.5" x2="11.5" y1="11.5" y2="11.5" />
      </g>
   </svg>
)

ActionModerateMessagesOutline12.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

ActionModerateMessagesOutline12.defaultProps = {
   className: undefined,
   color: '#444',
   height: '12px',
   strokeWidth: '1px',
   width: '12px'
}

export default React.memo(ActionModerateMessagesOutline12)
